import React from "react";

import { Card } from "@mui/material";

import DocumentsNeeded from "./DocumentsNeeded";
import PdfDocuments from "./PdfDocuments";
import Highlights from "./Highlights";
import usePolicyHighlight from "./usePolicyHighlight";
import ButtonGroupFooter from "../../Components/PersonalAccidentComponents/ButtonGroupFooter/ButtonGroupFooter";

export default function PolicyHighlightPage() {
  const {
    quickQuoteDetails,
    policyDetails,
    videoUrl,
    handleOnBuyPlan,
    handleOnBack,
  } = usePolicyHighlight();

  return (
    <>
      {Object.keys(quickQuoteDetails).length > 0 &&
      Object.keys(policyDetails).length > 0 ? (
        <div className="detailpage">
          <div className="">
            <Card
              style={{
                backgroundColor: "#0c409a",
                color: "white",
                padding: 20,
              }}
            >
              <div className="pro_heading">
                <div className="pro_image">
                  <img
                    alt="vendor_company_logo"
                    className="bg-white img-thumbnail rounded"
                    src={policyDetails?.company_logo}
                  />
                </div>
                <div>
                  <div className="text-capitalize">
                    {policyDetails?.policy_name} - {quickQuoteDetails?.coverType}
                  </div>
                  <div>{policyDetails?.company_name}</div>
                </div>
              </div>
              <div className="details_container">
                <div>
                  <div>
                    <div>Sum Assured</div>
                    <div>&#8377; {quickQuoteDetails?.sumInsuredValue}</div>
                  </div>
                </div>
                <div className="linewithdata">
                  <div className="line"></div>
                  <div>
                    <div>Premium Amount</div>
                    <div>&#8377; {quickQuoteDetails?.premium}</div>
                  </div>
                </div>
                <div className="linewithdata">
                  <div className="line"></div>
                  <div>
                    <div>Term</div>
                    <div>{quickQuoteDetails?.period} Years</div>
                  </div>
                </div>
              </div>
            </Card>
            <div>
              <p style={{ marginLeft: 20, marginTop: 20, fontSize: 20 }}>
                {policyDetails?.company_name}
              </p>

              <iframe
                id="video_url"
                src={`https://www.youtube.com/embed/${videoUrl}`}
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="video"
                height={250}
              />
            </div>

            <Card className="id_container">
              <div style={{ marginLeft: 20, marginTop: 20 }}>
                Document Needed
              </div>
              <DocumentsNeeded
                doc1={policyDetails?.document1}
                doc2={policyDetails?.document2}
                doc3={policyDetails?.document3}
                doc4={policyDetails?.document4}
              />
            </Card>

            <div className="pdf_container">
              <PdfDocuments
                doc1={policyDetails?.document_pdf1}
                doc2={policyDetails?.document_pdf2}
                doc3={policyDetails?.document_pdf3}
                doc4={policyDetails?.document_pdf4}
                doc5={policyDetails?.document_pdf5}
                docName1={policyDetails?.document_pdfname1}
                docName2={policyDetails?.document_pdfname2}
                docName3={policyDetails?.document_pdfname3}
                docName4={policyDetails?.document_pdfname4}
                docName5={policyDetails?.document_pdfname5}
              />
            </div>

            <div className="accor_container">
              <p style={{ marginLeft: 20, marginTop: 20, marginBottom: 50 }}>
                Policy Highlight
              </p>
              <Highlights highlights={policyDetails.highlight} />
            </div>
          </div>
          <ButtonGroupFooter
            rightButtonText="Buy Plan"
            handleLeftButtonClick={handleOnBack}
            handleRightButtonClick={handleOnBuyPlan}
          />
        </div>
      ) : (
        <h3>Please wait</h3>
      )}
    </>
  );
}
